<seznam-pocitadlolibise [attr.entity]="url">
  {{ url }}
</seznam-pocitadlolibise>
